<!--  -->
<template>
  <div class="sp_view">
    <div class="tabselecr_box">
      <div class="search_box">
        <el-input v-model="query.keywords" clearable style="width:300px;" placeholder="请输入企业id/外部用户id/客户姓名" />
        <el-button type="primary" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
      </div>
      <div>
        <!-- <el-button type="success" icon="el-icon-plus" @click="add(1)">新增</el-button> -->
      </div>
    </div>
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      border
    >
      <el-table-column
        prop="name"
        label="名字"
        align="center"
        width="240px"
      />
      <el-table-column
        prop="user_id"
        label="头像"
        align="center"
        width="100"
      >

        <template slot-scope="scope">
          <img :src="scope.row.avatar" alt="" style="width:50px">
        </template>
      </el-table-column>
      <el-table-column
        prop="corp_name_inner"
        label="企业名称"
        align="center"
        width="320"
      />
      <el-table-column
        prop="corp_id"
        label="企业id"
        align="center"
        width="320"
      />
      <el-table-column
        prop="external_user_id"
        label="外部客户id"
        align="center"
        width="300"
      />
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        align="center"
      />
      <el-table-column
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <!-- <el-button type="warning" size="mini" @click="prwiedit(scope.row)">预览</el-button>
          <el-button type="primary" size="mini" @click="look(scope.row)">拉取员工外部用户</el-button>
          <el-button type="danger" size="mini" @click="deteleter(scope.row.customer_message_no)">删除</el-button> -->
          <el-button type="primary" size="mini" @click="relevance(scope.row.external_user_id)">关联企业成员</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="关联企业成员" :visible.sync="dialogTableVisible" append-to-body :close-on-click-modal="false" :destroy-on-close="true">
      <enterdialog ref="enterviewr" />
    </el-dialog>

    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { spCorpexternalContactsList, spCorpfetchExternalContacts } from '@/api/officialaccount.js'
import enterdialog from './components/enterdialog.vue'
export default {
  name: 'EnterExternalemployees',
  components: { PaginationRight, enterdialog },
  data() {
    return {
      tableData: [],
      total: null,
      loading: false,
      query: {
        page: 1,
        pageSize: 10,
        keywords: null
        // corp_id: null,
        // external_userid: null
      },
      dialogTableVisible: false
    }
  },
  created() {
    this.list()
  },
  mounted() {

  },
  methods: {
    async list() {
      try {
        this.loading = true
        const data = await spCorpexternalContactsList(this.query)
        this.tableData = data.data.list
        this.total = data.data.total
        this.loading = false
        console.log('data', data)
      } catch {
        console.log('eee')
        this.loading = false
      }
    },
    async look(item) {
      console.log('item', item)
      const data = await spCorpfetchExternalContacts({
        user_id: item.user_id,
        corp_id: item.corp_id
      })
      this.$message({
        message: '拉取成功',
        type: 'success'
      })
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keywords = null
      this.list()
    },
    relevance(id) {
      this.dialogTableVisible = true
      this.$nextTick(() => {
        this.$refs.enterviewr.send(id)
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sp_view{
  padding: 30px;
}
.tabselecr_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
</style>
